/* eslint-disable @typescript-eslint/no-unused-vars */
import AvatarPlaceHolder from "../../assets/avatar-placeholder.jpg";
import LfbLogo from "../../assets/lfb-logo.svg";
import { guid } from "../../Helpers";
import {
  getMockLoan,
  getMockLoanApplications,
  getMockLoanApplicationsComments,
  getMockLoanApplicationsCondition,
  getMockLoanApplicationsEntities,
  getMockLoanApplicationsInfo,
  getMockLoanApplicationsProperty,
  getLoanStatusHistory,
  getLoanDetailsPropertyData,
  getMockLoanDetailsBudget,
  getMockLoanDetailsProposalCondition,
  getMockLoanDetailsClosinConditions,
  getMockLoanDetailsEntities,
  getMockLoanDetailsDocuments,
  getMockLoanDetailsLoanHistory,
  getMockLoanDetailsComments,
  getMockLoanDetailsDraws,
  getMockLoanDetailsInspectionMessages,
  getMockLoanDetailsAssignments,
  getMockLoanUploadBudget,
  getMockLoanAssignments,
  getMockLoanAssignmentHtml,
  getMockLoanAssignment,
  getLoanAssignmentPreviousRecordingDetail,
  getLoanAssignmentRecordingDetail,
  getLoanAssignmentDocumentLog,
  getMockOrganisationsInfoList,
  getMockOrganizationInfo,
  getMockOrganizationContacts,
  getMockVotingP2Polling,
  getMockVotingP2PollingDocuments,
  getMockVotingP2PollingMembersVote,
  getMockLoanDrawTempDetails,
  getMockLoanDrawTemp,
  getMockViewOptionsSample
} from "./MockLMSApi";
import { getMockDataPromise } from "../../helpers/GlobalHelper";
import { getMockGMRInfolist, updateMockGmrStatus } from "./MockBrokerApi";

const getMockProxyUsers = async () => {
  const mockData = [] as any[];
  for (let i = 0; i < 7; i++) {
    mockData.push(
      {
        id: guid(),
        firstName: `a${i}`,
        lastName: `b${i + 1}`,
        email: `c${i}@gmail.com`
      }
    );
  }

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const patchMockUser = async (patchObj) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const getMockTenantLogo = async () => {
  return await fetch(AvatarPlaceHolder);
};

const getMockTenantMetadata = async () => {
  const mockData = {
    themeColor: "#800020"
  };

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockTenantMetadataBySubdomain = async (subdomain) => {
  const mockData = {
    themeColor: "#800020"
  };

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockTenantLogoBySubdomain = async (subdomain) => {
  return await fetch(LfbLogo);
};

const getMetaData = () => {
  const mockData = {
    "accessLevels": [
      {
        "reference": "ApplicationAccessLevel",
        "id": "b5f4dd30-70a7-439b-8770-a6b60a55f891",
        "name": "Full Edit",
        "description": "",
        "sortOrder": 1
      },
      {
        "reference": "ApplicationAccessLevel",
        "id": "b15eefdc-305a-4774-9bc3-d30cca905a00",
        "name": "View Only",
        "description": "",
        "sortOrder": 2
      },
      {
        "reference": "ApplicationAccessLevel",
        "id": "ece51bab-0d81-412c-ab6d-6fc0e382f657",
        "name": "Limited",
        "description": "",
        "sortOrder": 3
      }
    ],
    "assignedTo": [
      {
        "id": "5d81179c-5086-41fb-806d-acc300e17d01",
        "name": "Alissa McCord",
        "role": "Loan Officer",
        "channelId": "2d35edc1-5d0b-46e8-a932-acc300e082b1"
      },
      {
        "id": "50f34376-b859-4af6-adfb-ad8700ad853a",
        "name": "Alissa McCord",
        "role": "Senior Sales Executive",
        "channelId": "2d35edc1-5d0b-46e8-a932-acc300e082b1"
      },
      {
        "id": "32410ee2-d670-4f45-bee8-ad9c015f7232",
        "name": "Beth Glein",
        "role": "Senior Sales Executive",
        "channelId": "541e0e59-db12-4bab-8f7b-acc300e07503"
      },
      {
        "id": "aa82d658-1113-4e97-b12f-acc300e1d509",
        "name": "Blake Rodgers",
        "role": "Loan Officer",
        "channelId": "2d35edc1-5d0b-46e8-a932-acc300e082b1"
      },
      {
        "id": "0cc35791-0efb-4e38-a5e0-ad8100a00e7e",
        "name": "Blake Rodgers",
        "role": "Senior Sales Executive",
        "channelId": "2d35edc1-5d0b-46e8-a932-acc300e082b1"
      },
      {
        "id": "5266e468-4319-42dc-89c7-ad4200dd4af6",
        "name": "Brian Stout",
        "role": "Loan Officer",
        "channelId": "19203bb3-5dc2-48f6-9f66-acc300e09296"
      },
      {
        "id": "b1a6a5e4-940f-4be8-b616-ad1d007a6421",
        "name": "Bruce Hardy",
        "role": "Loan Officer",
        "channelId": "19203bb3-5dc2-48f6-9f66-acc300e09296"
      },
      {
        "id": "42d5c1d6-73fd-430f-b7ee-acc300e1d509",
        "name": "Bryan Martin",
        "role": "Loan Officer",
        "channelId": "19203bb3-5dc2-48f6-9f66-acc300e09296"
      },
      {
        "id": "13c13197-6c75-4104-ba1d-ad9c015f5116",
        "name": "Bryan Ruff",
        "role": "Regional Sales Manager",
        "channelId": "541e0e59-db12-4bab-8f7b-acc300e07503"
      },
      {
        "id": "2add7df5-672f-495c-a856-acc300e1d509",
        "name": "Bryan Trent",
        "role": "Loan Officer",
        "channelId": "19203bb3-5dc2-48f6-9f66-acc300e09296"
      },
      {
        "id": "920e1625-1b90-4dd4-8f00-ad3c0096ce37",
        "name": "Cassie Busch",
        "role": "Loan Officer",
        "channelId": "2d35edc1-5d0b-46e8-a932-acc300e082b1"
      },
      {
        "id": "1364b6ef-6d31-45ca-aca4-ad4800b5d5fa",
        "name": "John Bohannon",
        "role": "Loan Officer",
        "channelId": "2d35edc1-5d0b-46e8-a932-acc300e082b1"
      },
      {
        "id": "402efa10-7017-48e7-ae00-acc300e1d509",
        "name": "Josh Cormany",
        "role": "Loan Officer",
        "channelId": "19203bb3-5dc2-48f6-9f66-acc300e09296"
      },
      {
        "id": "5b2dac75-03be-4e6c-bb8d-ad7900712bf4",
        "name": "Keenan Atkin",
        "role": "Loan Officer",
        "channelId": "541e0e59-db12-4bab-8f7b-acc300e07503"
      },
      {
        "id": "205f468e-688f-4a4f-998d-acc300e1f40a",
        "name": "Kendra Barile",
        "role": "Loan Officer",
        "channelId": "541e0e59-db12-4bab-8f7b-acc300e07503"
      },
      {
        "id": "5ae474a6-133d-4dda-8313-ad6d00c0b3a1",
        "name": "Oscar Mendez",
        "role": "Loan Officer",
        "channelId": "2d35edc1-5d0b-46e8-a932-acc300e082b1"
      },
      {
        "id": "768cced0-b864-4a0e-bbb4-acc300e17d06",
        "name": "Rich D'Agostino",
        "role": "Loan Officer",
        "channelId": "2d35edc1-5d0b-46e8-a932-acc300e082b1"
      },
      {
        "id": "8ca1e033-1d2d-424b-a051-ad8100a02303",
        "name": "Rich D'Agostino",
        "role": "Senior Sales Executive",
        "channelId": "2d35edc1-5d0b-46e8-a932-acc300e082b1"
      },
      {
        "id": "3d263cc8-cd5b-428f-a662-acc300e27a06",
        "name": "Robert Trent",
        "role": "Loan Officer",
        "channelId": "19203bb3-5dc2-48f6-9f66-acc300e09296"
      },
      {
        "id": "15a5d711-ffbb-4d9d-9cc7-acc300e1d509",
        "name": "Tyler Tietz",
        "role": "Loan Officer",
        "channelId": "19203bb3-5dc2-48f6-9f66-acc300e09296"
      }
    ],
    "assetTypes": [
      {
        "reference": "AssetType",
        "id": "37a2fd5a-93e2-43a1-8cd1-a7fa006c1640",
        "name": "Bank",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "AssetType",
        "id": "576465e5-c647-4ab2-bc0a-a81200dee0ca",
        "name": "Money in Escrow",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "AssetType",
        "id": "90609568-9135-48a9-97bd-a802005bbf78",
        "name": "Retirement",
        "description": "401Ks, etc.",
        "sortOrder": 0
      },
      {
        "reference": "AssetType",
        "id": "23f79667-5db4-4511-a6f1-a7fa006bf9a0",
        "name": "Stocks",
        "description": null,
        "sortOrder": 0
      }
    ],
    "borrowers": [
      {
        "reference": "Borrower",
        "id": "2ef6c068-b9ff-4652-aba8-7c57b95a28dd",
        "name": "Bob's Business",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "Borrower",
        "id": "1e0e5e94-f8c6-46c5-a2c4-fbf61a9ae4cd",
        "name": "New Borrower Bob",
        "description": null,
        "sortOrder": 0
      }
    ],
    "builders": [],
    "channels": [
      {
        "reference": "Channel",
        "id": "2d35edc1-5d0b-46e8-a932-acc300e082b2",
        "name": "Fix and Flip Channel",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "Channel",
        "id": "541e0e59-db12-4bab-8f7b-acc300e07503",
        "name": "Inside Sales",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "Channel",
        "id": "cd129023-3da1-43e6-9ac4-e3fa823cbf69",
        "name": "Production Builder",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "Channel",
        "id": "19203bb3-5dc2-48f6-9f66-acc300e09296",
        "name": "Retail Channel",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "Channel",
        "id": "2d35edc1-5d0b-46e8-a932-acc300e082b1",
        "name": "Wholesale Channel",
        "description": null,
        "sortOrder": 0
      }
    ],
    "builderInputs": [
      {
        "reference": "Builder",
        "id": "4b7fac75-2b86-44c4-9a51-614e3ac0c6b2",
        "name": "The Borrower Entity will be acting as General Contractor",
        "description": null,
        "sortOrder": 100
      },
      {
        "reference": "Builder",
        "id": "c300f4af-faad-4866-b570-6bac952e39a2",
        "name": "The Borrower Entity will be hiring a licensed General Contractor",
        "description": null,
        "sortOrder": 100
      }
    ],
    "commentCategories": [
      {
        "reference": "CommentCategory",
        "id": "b6a30147-56b6-409f-a031-9e0d10c0526a",
        "name": "Application",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "CommentCategory",
        "id": "7342f28a-ecaf-4e88-9f6d-aca900da3a40",
        "name": "Physical Documents",
        "description": null,
        "sortOrder": 0
      },
    ],
    "commentSubjects": [
      {
        "commentCategoryId": "c07e3f86-cf44-44b3-8df8-3900be34448c",
        "reference": "CommentSubject",
        "id": "b3779a6b-2929-4287-9a6d-2712a0ac22cf",
        "name": "Borrower",
        "description": null,
        "sortOrder": 0
      },
      {
        "commentCategoryId": "7b16f0fa-9bae-42a4-bfcc-2f628014d6ad",
        "reference": "CommentSubject",
        "id": "3dc557df-7316-4816-b961-abde0090c7c4",
        "name": "Receivership ",
        "description": null,
        "sortOrder": 0
      },
    ],
    "entitySubTypes": [
      {
        "reference": "EntitySubType",
        "id": "fb846206-a4ac-4263-8f13-ca100a4ea5fb",
        "name": "Corporation",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "EntitySubType",
        "id": "2612f736-32dc-4550-9396-a64401374f4d",
        "name": "Limited Liability Company",
        "description": null,
        "sortOrder": 0
      },
    ],
    "entityTypes": [
      {
        "reference": "EntityType",
        "id": "35f235b2-324b-43e5-9467-a65200cfae5d",
        "name": "Appraiser",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "EntityType",
        "id": "dadd6830-5f9d-43d9-a449-bbaa7bad2afa",
        "name": "Borrower",
        "description": null,
        "sortOrder": 0
      },
    ],
    "gmrprojectCosts": [
      {
        "reference": "GMRProjectCost",
        "id": "5e275c46-96e0-403d-be44-2b1e3b7c4de5",
        "name": "Construction Costs (Not Financed)",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "GMRProjectCost",
        "id": "e1c6035a-ecb9-4486-9a5a-d51351f3091a",
        "name": "Development Costs (Not Financed)",
        "description": null,
        "sortOrder": 0
      },
    ],
    "guarantors": [
      {
        "reference": "Guarantor",
        "id": "caf4df4e-325b-4844-b39e-173e6f382903",
        "firstName": "Slobodan",
        "lastName": "Mihajlovic",
        "email": "smguarantor17@gmail.com",
        "sortOrder": 0
      }
    ],
    "interestCalculationMethods": [
      {
        "reference": "InterestReserve",
        "id": "60fc9905-b347-486a-82a5-6948274dcab4",
        "name": "Monthly Payments",
        "description": null,
        "sortOrder": 100
      },
      {
        "reference": "InterestReserve",
        "id": "af0cc887-8d1b-43c5-b02c-a0056ab80b20",
        "name": "Interest Reserve",
        "description": null,
        "sortOrder": 100
      }
    ],
    "liabilityTypes": [
      {
        "isBuiltIn": true,
        "reference": "LiabilityType",
        "id": "009c4f7b-88eb-4bbc-ba9d-a811010782d6",
        "name": "Mortgage",
        "description": null,
        "sortOrder": 0
      },
      {
        "isBuiltIn": true,
        "reference": "LiabilityType",
        "id": "1434ae02-82ab-46f6-83dc-a811010789db",
        "name": "Line of Credit",
        "description": null,
        "sortOrder": 0
      },
    ],
    "loanOfficers": [
      {
        "id": "389ba857-616a-45e6-9947-a67500cea892",
        "name": "Alissa McCord"
      },
      {
        "id": "1c7b3a6b-8e3c-445d-ae7b-a67500dea1c6",
        "name": "Courtney Altig"
      },
      {
        "id": "1e02b32b-43ba-4ca8-b4fd-a67a011c0b6c",
        "name": "Rich D'Agostino"
      },
    ],
    "loanPrograms": [
      {
        "reference": "LoanProgram",
        "id": "fd4c0567-8745-411e-b992-40cae5c9bd60",
        "name": "New Construction",
        "description": "Vertical Construction of New Homes",
        "sortOrder": 0
      },
      {
        "reference": "LoanProgram",
        "id": "a8804f37-5154-42dd-86ff-a8a800eca6d0",
        "name": "Bridge",
        "description": "Purchase or Refinance of an existing structure without a construction budget",
        "sortOrder": 0
      },
      {
        "reference": "LoanProgram",
        "id": "09fcb6e2-c45e-4961-be52-a8a800f05b6a",
        "name": "Fix and Flip",
        "description": "Rehab of an existing structure",
        "sortOrder": 0
      },
    ],
    "maritalStatuses": [
      {
        "reference": "MaritalStatus",
        "id": "663710eb-f41f-4298-9bc6-a657013c7898",
        "name": "Married",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "MaritalStatus",
        "id": "bcbcfd75-de63-4364-92e3-a657013d2d41",
        "name": "Separated",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "MaritalStatus",
        "id": "2f9aacac-82d3-4822-a5e0-a657013c7ed9",
        "name": "Unmarried",
        "description": null,
        "sortOrder": 0
      }
    ],
    "ownershipInputs": [
      {
        "reference": "Ownership",
        "id": "e0531d10-29d0-4619-8e32-8d502f8f5bb2",
        "name": "More than two years",
        "description": null,
        "sortOrder": 100
      },
      {
        "reference": "Ownership",
        "id": "1738becb-a35d-4a7e-a7a2-93cddd85c57b",
        "name": "Less than two years",
        "description": null,
        "sortOrder": 100
      }
    ],
    "payoffStrategies": [
      {
        "reference": "PayoffStrategy",
        "id": "66b0c1d8-53fa-481b-8879-1b3346a0fdb0",
        "name": "Other",
        "description": null,
        "sortOrder": 0
      },
    ],
    "permitStatuses": [
      {
        "reference": "PermitStatus",
        "id": "bbeb1c5d-0887-4445-8c54-a64400fe1889",
        "name": "Expired",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "PermitStatus",
        "id": "c87fc9d1-8d80-4ccd-82c9-a64400fe2ae9",
        "name": "Final Engineering",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "PermitStatus",
        "id": "3591db95-8374-4e9a-9dc7-a64400fe12f1",
        "name": "Issued",
        "description": null,
        "sortOrder": 0
      },
    ],
    "propertyTypes": [
      {
        "reference": "PropertyType",
        "id": "e9240848-0fce-4f21-9e2c-a371adaad0bc",
        "name": "Single Family",
        "description": null,
        "sortOrder": 1
      },
      {
        "reference": "PropertyType",
        "id": "2ed7546f-c9ee-486d-94dd-ee681219ffee",
        "name": "Townhome",
        "description": null,
        "sortOrder": 2
      },
    ],
    "purchaseRefinance": [
      {
        "id": "f2820074-37f8-4485-a8a0-f3189e4147d6",
        "name": "Purchase",
        "description": null,
        "ccRecepients": null
      },
    ],
    "reoStatuses": [
      {
        "reference": "REOStatus",
        "id": "922046e6-778f-4249-abc2-a80900a1a5d5",
        "name": "Owned",
        "description": null,
        "sortOrder": 0
      },
    ],
    "reoTypes": [
      {
        "reference": "REOType",
        "id": "61a7365f-86c5-4c40-bf93-a811010dac55",
        "name": "Apartment",
        "description": null,
        "sortOrder": 0
      },
    ],
    "workStages": [
      {
        "reference": "WorkStage",
        "id": "04640fa1-0e11-4f5e-86eb-acad01032f56",
        "name": "Work Not Started",
        "description": null,
        "sortOrder": 1
      },
    ],
    "yesNoUnknownInputs": [
      {
        "reference": "YesNoUnknown",
        "id": "759b77ab-f92b-4980-ba2c-5f90a4c0cf6a",
        "name": "No",
        "description": null,
        "sortOrder": 200
      },
    ]
  };

  return getMockDataPromise(mockData);
};

const allMockApiCalls = {
    "borrowerapplication/infolist": getMockLoanApplications,
    "loans/info/4d71f03d-396e-481c-bf2d-c70e33516736": getMockLoanApplicationsInfo,
    "loanProperties": getMockLoanApplicationsProperty,
    "loanEntities": getMockLoanApplicationsEntities,
    "loanComments": getMockLoanApplicationsComments,
    "loanCondition": getMockLoanApplicationsCondition,
    "loanStatusHistory" : getLoanStatusHistory,
    "loanDetailsProperty" : getLoanDetailsPropertyData,
    "loanDetailsBudget" : getMockLoanDetailsBudget,
    "loanDetailsProposalConditions" : getMockLoanDetailsProposalCondition,
    "loanDetailsClosingConditions" : getMockLoanDetailsClosinConditions,
    "loanDetailsEntities" : getMockLoanDetailsEntities,
    "loanDetailsDocuments" : getMockLoanDetailsDocuments,
    "loanDetailsLoanHistory" : getMockLoanDetailsLoanHistory,
    "loanDetailsComments" : getMockLoanDetailsComments,
    "loanDetailsDraws" : getMockLoanDetailsDraws,
    "loanDetailsInspectionsMessages" : getMockLoanDetailsInspectionMessages,
    "loanDetailsAssignments" : getMockLoanDetailsAssignments,
    "loanUploadBudget" : getMockLoanUploadBudget,
    "loanAssignments" : getMockLoanAssignments,
    "loanAssignment" : getMockLoanAssignment,
    "loanAssignmentHtml" : getMockLoanAssignmentHtml,
    "loanAssignmentPreviousRecordingDetail" : getLoanAssignmentPreviousRecordingDetail,
    "loanAssignmentRecordingDetail" : getLoanAssignmentRecordingDetail,
    "loanAssignmentDocumentLog" : getLoanAssignmentDocumentLog,
    "deal": getMockLoan,
    "metadata/list": getMetaData,
    "orgs/info-list": getMockOrganisationsInfoList,
    "orgs/info/id": getMockOrganizationInfo,
    "/voting/list-p2-polling": getMockVotingP2Polling,
    "/voting/p2-polling/id/documents": getMockVotingP2PollingDocuments,
    "/voting/p2-polling/id/members-vote": getMockVotingP2PollingMembersVote,
    "getOrganizationContacts": getMockOrganizationContacts,
    "gmr/infolist": getMockGMRInfolist,
    "gmr/update-status": updateMockGmrStatus,
    "draws/loan-draw-temp": getMockLoanDrawTemp,
    "draws/loan-draw-temp/id": getMockLoanDrawTempDetails,
    "viewOptionsMock": getMockViewOptionsSample,
};

export {
  getMockProxyUsers,
  patchMockUser,
  getMockTenantLogo,
  getMockTenantMetadata,
  getMockTenantMetadataBySubdomain,
  getMockTenantLogoBySubdomain,
  allMockApiCalls
};